import styled from "styled-components";

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  width: 100%;
`;

export default CardContent;
